import './trendingArrow.css';

export default function TrendingArrow({net}) {
    return (
        <div className={net ? 'positive-trend' : 'negitive-trend'}>
            <svg width="34" height="34" viewBox="0 0 34 34">
                <circle id="Ellipse_158" data-name="Ellipse 158" cx="17" cy="17" r="17" fill="#8ce68c"/>
                <path id="Icon_ion-arrow-left-c" data-name="Icon ion-arrow-left-c" d="M12.857,8.989,6.221,15.937a2.142,2.142,0,0,0,0,2.964l6.637,6.974a1.957,1.957,0,0,0,2.859,0,2.189,2.189,0,0,0,0-2.991L12.533,19.55H26.892a2.12,2.12,0,0,0,0-4.235H12.533l3.189-3.335a2.189,2.189,0,0,0,0-2.991A1.964,1.964,0,0,0,12.857,8.989Z" transform="translate(41.6 16.614) rotate(135)" fill="#f8fdff"/>
            </svg>
        </div>
    )
};